/**
 * @class YouTube
 * Initializes a YouTube iframe instance to play a video.
 * @construct {HTMLElement} el HTML element to replace with a vimeo iframe
 */
var YouTube = /** @class */ (function () {
    function YouTube(el) {
        this.container = el;
        this.videoID = this.container.dataset.id;
        this.video = null;
        if (!this.videoID) {
            return;
        }
        this.createPlayer = this.createPlayer.bind(this);
        this.init();
    }
    YouTube.prototype.createPlayer = function () {
        var _this = this;
        var videoArea = document.createElement('div');
        this.container.appendChild(videoArea);
        this.video = new window.YT.Player(videoArea, {
            videoId: this.videoID,
            playerVars: {
                autoplay: 1,
                controls: 0,
                disablekb: 1,
                enablejsapi: 1,
                fs: 0,
                loop: 1,
                modestbranding: 1,
                playsinline: 1,
                rel: 0,
            },
            events: {
                onReady: function () {
                    var _a, _b;
                    (_a = _this.video) === null || _a === void 0 ? void 0 : _a.mute();
                    (_b = _this.video) === null || _b === void 0 ? void 0 : _b.playVideo();
                    setTimeout(function () {
                        var _a;
                        (_a = _this.video) === null || _a === void 0 ? void 0 : _a.seekTo(0, true);
                        _this.container.classList.add('oembed-video--playing');
                    }, 4500);
                },
                onStateChange: function (e) {
                    var _a;
                    if (e.data === window.YT.PlayerState.ENDED) {
                        (_a = _this.video) === null || _a === void 0 ? void 0 : _a.seekTo(0, true);
                    }
                },
            },
        });
    };
    YouTube.prototype.init = function () {
        if (window.YT) {
            this.createPlayer();
        }
        else {
            window.addEventListener('youtube-ready', this.createPlayer);
        }
    };
    return YouTube;
}());
var youtubeInit = {
    init: function () {
        var wrapperEl = document.querySelectorAll('.oembed-video--youtube');
        Array.from(wrapperEl).forEach(function (el) {
            var htmlEl = el;
            new YouTube(htmlEl);
        });
    },
};
export default youtubeInit;
